<template>
  <ImageCard
    :heading="t('jc.component.participateCallCard.heading')"
    :paragraph="t('jc.component.participateCallCard.paragraph')"
    :image="{ src: 'images/component/participateCallCard/background.png' }"
  >
    <NuxtLink
      :target="'_blank'"
      :to="config.public.discordParticipateUrl"
      :title="t('jc.component.participateCallCard.link.title')"
      class="bg-primary hover:bg-primary-highlighted active:bg-primary-selected text-white
            text-center rounded py-2 px-4 mt-10 mx-auto font-semibold"
    >
      <font-awesome-icon
        :icon="{ prefix: 'fab', iconName: 'discord' }"
        class="mr-2"
      />
      <span>{{ t('jc.component.participateCallCard.link.label') }}</span>
    </NuxtLink>
  </ImageCard>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const { t } = useI18n()
const config = useRuntimeConfig()
</script>
